import  { useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/future/image";

import Link from "next/link";
 import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Col, Container, Form, Row } from "react-bootstrap";
import { v4 } from "uuid";
 
import arrow from "../../assets/images/arrow-up.png";
import NourSeen from "../../assets/images/nour-seen-logo.png";
import markerIco from "../../assets/images/svg/contact/22.svg";
import mailIco from "../../assets/images/svg/contact/33.svg";
import callIco from "../../assets/images/svg/contact/11.svg";
import { FormattedMessage, useIntl } from "react-intl";
 import server from "../../api/server";
import { handleImage } from "../../utils";

const Footer = ({ initData }) => {
  const { pathname } = useRouter();
  const closeNav = () => {
    document.querySelector(".nav-sidebar").classList.remove("active");
    document.querySelector("html").classList.remove("off");
  };

  const { formatMessage, locale } = useIntl();
  const neededInfo = initData?.socials?.filter((link) =>
    ["phone", "email", "location address", "location address_en"]?.includes(
      link?.socialType?.name?.en
    )
  );

  const socials = initData?.socials?.filter(
    (link) =>
      ![
        "phone",
        "email",
        "location address",
        "location address_en",
        "working hours",
        "working hours",
      ]?.includes(link?.socialType?.name?.en)
  );
  const workingHours = initData?.socials?.filter((link) =>
    ["working hours"]?.includes(link?.socialType?.name?.en)
  );
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    await server.post("/subscribers", data);
    reset();
    Swal.fire(
      `${formatMessage({
        id: "thanks",
      })}`,
      `${formatMessage({
        id: "thankMsg",
      })}`,
      "success"
    );
  };

  useEffect(() => {
    const scrollProcess = () => {
      let scrollPos = 700;
      const ScrollBtn = document?.querySelector(".scrollTop");
      function checkPosition() {
        let windowY = window.scrollY || 0;
        if (windowY > scrollPos) {
          // Scrolling UP
          ScrollBtn.classList.add("active");
        } else {
          // Scrolling DOWN
          ScrollBtn.classList.remove("active");
        }
        // scrollPos = windowY;
      }
      window.addEventListener("scroll", checkPosition);
    };

    scrollProcess();
  });

  const scrolly = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="main-footer">
        <div className="footer-top">
          <Container>
            <div className="logo">
              <Link href="/">
                <a aria-label="go-to-logo">
                  <div className="logo-descktop">
                    <Image
                    style={{minHeight:'120px'}}
                      src={
                        handleImage(initData?.siteInfo?.appLogo?.[locale]) ||
                        logo.src
                      }
                 width={250}
                 height={120}
                      alt="logo"
                    
                     
                    />
                  </div>
                </a>
              </Link>
            </div>
            <Row>
              <Col xl={4} lg={3} md={12} xs={12}>
                <h4>
                  <FormattedMessage id="helpLinks" />
                </h4>

                <div className="main-menu">
                  <ul onClick={closeNav}>
                    <li className={pathname == "/" ? "active" : ""}>
                      <Link href="/">
                        <a aria-label="go-to-home">
                          <FormattedMessage id="home" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/about" ? "active" : ""}>
                      <Link href="/about">
                        <a aria-label="go-to-about">
                          <FormattedMessage id="about" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/services" ? "active" : ""}>
                      <Link href="/services">
                        <a aria-label="go-to-services">
                          <FormattedMessage id="services" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/teamMembers" ? "active" : ""}>
                      <Link href="/teamMembers">
                        <a aria-label="go-to-teamMembers">
                          <FormattedMessage id="teamMembers" />
                        </a>
                      </Link>
                    </li>
                   
                    <li className={pathname == "/blog" ? "active" : ""}>
                      <Link href="/blog">
                        <a aria-label="go-to-blog">
                          <FormattedMessage id="blog" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/contact" ? "active" : ""}>
                      <Link href="/contact">
                        <a aria-label="go-to-contact">
                          <FormattedMessage id="contact" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/faqs" ? "active" : ""}>
                      <Link href="/faqs">
                        <a aria-label="go-to-faqs">
                          <FormattedMessage id="faqs" />
                        </a>
                      </Link>
                    </li>
                    <li className={pathname == "/hiring" ? "active" : ""}>
                      <Link href="/hiring">
                        <a aria-label="go-to-askEmployee">
                          <FormattedMessage id="askEmployee" />
                        </a>
                      </Link>
                    </li>

                    <li className={pathname == "/privacy" ? "active" : ""}>
                      <Link href="/privacy">
                        <a aria-label="go-to-privacy">
                          <FormattedMessage id="Privacy Policy" />
                        </a>
                      </Link>
                    </li>

                    <li className={pathname == "/terms" ? "active" : ""}>
                      <Link href="/terms">
                        <a aria-label="go-to-terms">
                          <FormattedMessage id="Terms and Conditions Policy" />
                        </a>
                      </Link>
                    </li>
                  </ul>
                  <Link href="/hiring">
                    <a aria-label="go-to-hiring" className="btn mt-4">
                      <FormattedMessage id="downloadProfile" />
                    </a>
                  </Link>
                </div>
               
              </Col>
              <Col xl={4} lg={3} md={6} xs={12}>
                <h4>
                  <FormattedMessage id="contactVia" />
                  ...{" "}
                </h4>

                <ul>
                  <li>
                    <div className="i-img">
                      <Image
                        src={callIco.src}
                        width={22}
                        height={22}
                        alt=""
                      
                        loading="lazy"
                      />
                    </div>
                    <p>
                      <Link
                        href={`tel:${
                          neededInfo?.filter(
                            (link) => link?.socialType?.name?.en === "phone"
                          )[0]?.link
                        }`}
                      >
                        <a 
                        aria-label="go-to-phone"
                        >
                          {
                            neededInfo?.filter(
                              (link) => link?.socialType?.name?.en === "phone"
                            )[0]?.link
                          }
                        </a>
                      </Link>
                    </p>
                  </li>
                  <li>
                    <div className="i-img">
                      <Image
                        src={mailIco.src}
                        width={22}
                        height={22}
                        alt=""
                      
                        loading="lazy"
                      />
                    </div>
                    <p>
                      <Link
                        href={`mailto:${
                          neededInfo?.filter(
                            (link) => link?.socialType?.name?.en === "email"
                          )[0]?.link
                        }`}
                      >
                        <a 
                         aria-label="go-to-email"
                        >
                          {
                            neededInfo?.filter(
                              (link) => link?.socialType?.name?.en === "email"
                            )[0]?.link
                          }
                        </a>
                      </Link>
                    </p>
                  </li>
                  <li>
                    <div className="i-img" style={{ minWidth: "22px" }}>
                      <Image
                        src={markerIco.src}
                        width={22}
                        height={22}
                        alt=""
                      
                        loading="lazy"
                      />
                    </div>
                    <p>
                      {
                        neededInfo?.filter(
                          (link) =>
                            link?.socialType?.name?.en ===
                            `location address${locale === "ar" ? "" : "_en"}`
                        )[0]?.link
                      }
                    </p>
                  </li>
                </ul>

                <div className="social">
                  {socials?.map((social , idx) => {
                    return (
                      <Link href={social?.link} key={v4()}>
                        <a
                          target={"_blank"}
                          aria-label={`social-${social?.socialType?.name.en}`}
                        >
                          <Image
                            src={`${process.env.NEXT_PUBLIC_MAIN_URL}${social?.socialType?.icon}`}
                            width={15}
                            height={15}
                            alt="social image"
                          
                            loading="lazy"
                          />
                        </a>
                      </Link>
                    );
                  })}
                </div>
              </Col>

              <Col xl={4} lg={3} md={12} xs={12}>
                <h4>
                  <FormattedMessage id="newsLetter" />
                </h4>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder={formatMessage({ id: "email" })}
                      {...register("email", { required: true })}
                    />
                    {errors.name && (
                      <p className="error-hint">
                        {formatMessage({ id: "emailRequired" })}
                      </p>
                    )}
                    <button type="submit" className="btn">
                      <FormattedMessage id="subscripe" />
                    </button>
                  </div>
                </form>
                <div className="work-times">
                  <h4>
                    <FormattedMessage id="workTimes" />
                  </h4>
                  <ul>
                    {workingHours?.map((shift) => (
                      <li key={v4()}>
                        {shift?.name?.[locale]} : {shift?.link}
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer-bottom">
          <Container>
            <p>
              <FormattedMessage id="DevCompany" />
              <Link href="http://nsn.sa/" passHref>
                <a target="_blank" aria-label="developed by image">
                  <Image
                    src={NourSeen.src}
                    width="50"
                    height="40"
                    alt="developed by image"
                    loading="lazy"
                  />
                </a>
              </Link>
              <FormattedMessage id="Rights" />
            </p>
          </Container>
        </div>
        <button
          onClick={scrolly}
          className="scrollTop"
          type="button"
          aria-label="scroll to top button"
        >
          <Image
            src={arrow.src}
            width={10}
            height={20}
            alt=""
          
            loading="lazy"
          />
        </button>
      </footer>
    </>
  );
};

export default Footer;
